module.exports = __webpack_public_path__ + "img/president-dwight-d.-eisenhower.1cf62c38.png";